import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { GenericResponseDto } from "../models/generic-response.dto";
import { GetExtisingPOIdRequest } from "../models/orders/getExtisingPOIdRequest";
import { GetExtisingPOIdResponse } from "../models/orders/getExtisingPOIdResponse";

@Injectable({
  providedIn: "root",
})
export class PurchaseOrderSidebarService {
  private d365SynchroniserBaseURL = environment.baseUrl + "/D365Synchroniser";

  constructor(private _http: HttpClient) {}

  GetExtisingPOId(
    payload: GetExtisingPOIdRequest
  ): Observable<GenericResponseDto<GetExtisingPOIdResponse>> {
    return this._http.post<GenericResponseDto<GetExtisingPOIdResponse>>(
      this.d365SynchroniserBaseURL + "/GetExtisingPOId",
      payload
    );
  }
}
